import { observer } from "mobx-react";
import * as React from "react";
import styles from "./styles/Content.module.css";
import { useStores } from "@/hooks/useStores";

interface ContentProps {
    children: React.ReactNode;
}

export const Content = observer(({ children }: ContentProps) => {
    const { playerStore } = useStores();
    const cls = playerStore.active ? `${styles.content} ${styles.player}` : styles.content;
    return <div className={cls}>{children}</div>;
});
